import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormBuilder } from '@angular/forms';

import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

import { ComponentBuilder } from '../../ComponentBuilder';

@Component({
  selector: 'app-translation-switcher-builder',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, ButtonModule, InputTextModule],
  templateUrl: './translationSwitcherBuilder.component.html',
  styleUrl: './translationSwitcherBuilder.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TranslationSwitcherBuilderComponent extends ComponentBuilder {
  public componentName = 'TranslationSwitcher';
}
